import NavBar from './NavBar.vue'

export default NavBar
